import {Component, OnInit, Inject, Input, InjectionToken} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatDialog} from '@angular/material';
import {Router} from '@angular/router';
import {Paginate} from '../../search-document-sign/search-document-sign.component';
import {DataSource} from '@angular/cdk/collections';
import {BehaviorSubject, Observable} from 'rxjs';
import {DocumentService} from 'src/app/core/services/document.service';
import {debug} from 'util';
import {ApprovalDocumentComponent} from '../../approval-document/approval-document.component';
import {DeclineApproveDocumentComponent} from '../../decline-approve-document/decline-approve-document.component';
import {ApproveDocumentListComponent} from '../approve-document-list/approve-document-list.component';
import {Message} from '../../../../../../../core/class/message';
import {CommonService} from '../../../../../../../core/services/common.service';

/**
 * The document model.
 */
export class Document {
  name: string;
  id: string;
  code: string;
  createdTime: string;
  finishDate: string;
  createdUser: string;
  customerName: string;
  taxCode: string;
  customerTaxCode: string;
  customerCertificateNo: string;
  status: number;
  parentId: string;
  enterprise: string;
  documentType: any;
  type: any;
  email: string;
  checked: boolean;
}

/**
 * document source.
 */
export class DocumentDataSource extends DataSource<Document> {
  /** Stream of data that is provided to the table. */
  public data = new BehaviorSubject<Document[]>([]);

  /**
   * Create new instance.
   */
  constructor() {
    super();
  }


  setData(data: Document[]) {

    this.data.next(data);
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<Document[]> {
    return this.data.asObservable();
  }

  disconnect(): void {
    this.data.complete();
  }
}

@Component({
  selector: 'app-decline-approve-document-list',
  templateUrl: './decline-approve-document-list.component.html',
  styleUrls: ['./decline-approve-document-list.component.scss']
})

/**
 * Sign document list component.
 */
export class DeclineApproveDocumentListComponent implements OnInit {

  /**
   * stop sign action.
   */
  public static CONFIRM_ACTION = 'confirm';

  public static CONFIRM_ACTION_NON_CERTIFICATE = 'confirm2';

  /**
   * close popup action.
   */
  public static CLOSE_ACTION = 'close';

  public static DECLINE_ACTION = 'decline';
  public static DECLINE_ALL_ACTION = 'decline-all';


  /**
   * sign all document.
   */
  public static SIGN_ALL = 'all';

  /**
   * Sign a slot.
   */
  public static SIGN_SLOT = 'slot';

  public static TYPE_CONTRACT_NON_CERTIFICATE = 'non certificate';

  public static TYPE_CONTRACT_WITH_CERTIFICATE = 'with certificate';

  public static TYPE_CONTRACT_MIX_CERTIFICATE = 'mix certificate';

  /**
   * Stream of data that is provided to the table.
   */
  public actions = new BehaviorSubject<string>('');

  /**
   * sign option.
   */
  private signOption: string;

  /**
   * slot of documents.
   */
  private slotDocuments: any;

  /**
   * filter by sign all condition.
   */
  private filterSignAll: any;

  dataSource: any;

  tmp: any;

  paginate: Paginate;

  documents = new Document();

  noOfFiles: 0;

  conTractWithCertificate: 0;
  typeContracts: string;
  conTractWithoutCertificate: 0;

  notifyWarning: string;

  displayedColumns: string[] = [
    'STT',
    'contractName',
    'noOfFile',
    'allName',
    'createdUser',
    'receivedTime'
    // 'symbol',
  ];

  /**
   *
   * @param data
   *   + signOption sign option.
   *   + slotDocuments slot of documents.
   *   + filterSignAll filter option of sign all.
   * @param router The router.
   * @param documentService The document service.
   */
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      signOption: string,
      slotDocuments: any,
      filterSignAll: any
    },
    private router: Router,
    private documentService: DocumentService,
    private dialog: MatDialog,
    private message: Message,
    private commonService: CommonService,
  ) {
    this.signOption = data.signOption;
    this.slotDocuments = data.slotDocuments;
    this.filterSignAll = data.filterSignAll;
  }

  /**
   * Initialize data.
   */
  ngOnInit() {
    if (this.signOption === DeclineApproveDocumentListComponent.DECLINE_ALL_ACTION) {
      this.loadDocumentsBySignAll();
    } else {
      console.log('slot: ' + JSON.stringify(this.slotDocuments));
      const dataSource = this.slotDocuments.value.map(item => ({
        ...item,
        contractName: item.name,
      }));
      this.noOfFiles = dataSource.reduce(function(s, a) {
        return s + a.contractAttachments.length;
      }, 0);
      if (!dataSource.some(item => item.isSignDigitalCertificate === true)) {
        this.typeContracts = ApproveDocumentListComponent.CONFIRM_ACTION_NON_CERTIFICATE;
      } else if (!dataSource.some(item => item.isSignDigitalCertificate === false)) {
        this.typeContracts = ApproveDocumentListComponent.TYPE_CONTRACT_WITH_CERTIFICATE;
      } else {
        this.typeContracts = ApproveDocumentListComponent.TYPE_CONTRACT_MIX_CERTIFICATE;
      }
      this.conTractWithCertificate = dataSource.filter((item) => item.isSignDigitalCertificate === true).length;
      this.conTractWithoutCertificate = dataSource.filter((item) => item.isSignDigitalCertificate === false).length;

      const validData = dataSource.filter(x => x.status === 2 && x.cStatus !== 3 && x.cStatus !== 5);
      const notifyWarningStr = this.commonService.format(this.message.getMessage('messages.warning_multi_refuse_lot'), dataSource.length - validData.length, dataSource.length, validData.length);
      this.notifyWarning = validData.length === dataSource.length ? '' : notifyWarningStr;
      this.dataSource = validData;
    }
  }

  /**
   * View document detail.
   * @param id The document id.
   */
  viewDetail(id) {
    this.router.navigate(['/home-enterprise/view-document/' + id]);
  }

  /**
   * Click on cancel button.
   */
  onClickCancelButton() {
    this.actions.next(DeclineApproveDocumentListComponent.CLOSE_ACTION);
  }

  /**
   * Click on confirm button.
   */
  onClickConfirmButton() {
    this.actions.next(DeclineApproveDocumentListComponent.DECLINE_ACTION);
    // this.dialog.open(DeclineApproveDocumentComponent, {
    //   width: '40%',
    //   data: {
    //     document: this.dataSource
    //   }
    // });
  }

  /**
   * Load document by sign all.
   */
  private loadDocumentsBySignAll() {
    this.documentService.getDocumentsByApproveAll(this.filterSignAll)
      .subscribe(rs => {
        if (rs && rs.data) {
          console.log('rs.data', rs.data);

          this.dataSource = rs.data;
          this.noOfFiles = this.dataSource.reduce(function(s, a) {
            return s + a.contractAttachments.length;
          }, 0);
        }
        if (!this.dataSource.some(item => item.isSignDigitalCertificate === true)) {
          this.typeContracts = ApproveDocumentListComponent.CONFIRM_ACTION_NON_CERTIFICATE;
        } else if (!this.dataSource.some(item => item.isSignDigitalCertificate === false)) {
          this.typeContracts = ApproveDocumentListComponent.TYPE_CONTRACT_WITH_CERTIFICATE;
        } else {
          this.typeContracts = ApproveDocumentListComponent.TYPE_CONTRACT_MIX_CERTIFICATE;
        }
        this.conTractWithCertificate = this.dataSource.filter((item) => item.isSignDigitalCertificate === true).length;
        this.conTractWithoutCertificate = this.dataSource.filter((item) => item.isSignDigitalCertificate === false).length;

      });
  }

}
